const createReferalStep1 = document.querySelector('[create-new-referal]') || null;
const sendRefralStep2 = document.querySelector('[send-referal-to-friends]') || null;
const stepNext = document.querySelector('[step-control-next]') || null;
const myEmail = document.querySelector('[my-email]') || null;
const customerEmails = document.querySelector('[refer-friend-email]') || null;

const id = sendRefralStep2.querySelector('[my-customer-id]').value;
const referalURl = `https://www.nosmeilleursglobal.com/account/register?referral=${id}`;

stepNext.addEventListener('click', function() {
 //debugger
  if(stepNext.dataset.next == '0') {
    const data = {
      referral_email: myEmail.value,
      referral_name: createReferalStep1.querySelector('[my-name]').value,
      referral_id: createReferalStep1.querySelector('[my-customer-id]').value
    }
    //create_new_referal(data);
  }
  
});

function share_fb() {
  window.open('https://www.facebook.com/sharer/sharer.php?u='+referalURl,'facebook-share-dialog',"width=626, height=436")
}
function share_tw() {
  window.open('https://twitter.com/intent/tweet?text='+referalURl,'twitter-share-dialog',"width=626, height=436")
}
function share_wa() {
  window.open('whatsapp://send?text='+referalURl,'whatsapp-share-dialog',"width=626, height=436")
}
function copy_link() {
  // Get the text field
  var copyText = referalURl;

  // Select the text field
  //copyText.select();
  //copyText.setSelectionRange(0, 99999); // For mobile devices

   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText);

  // Alert the copied text
  alert("Copied the text: " + copyText);
}

const create_new_referal = (data) => {
  
  // formData.append('customer_id', customerid);
  
  const options = {
    method: "POST",
     headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  };
  const fetchUrl = `/apps/express-proxy/referal/create-referal`;
  return fetch(fetchUrl, options)
  .then((res) => res.json())
  .then((res) => {
    debugger
    const data = res.data;
    return data;
  })
  .catch((err) => console.error(`[Shopify Create Referal] Failed to load content for`, err));
};   